import React, { useMemo } from 'react';
import { View } from 'react-native';
import MoreHealthSVG from '~/assets/svgs/moreHealthLogo.svg';
import { Text } from '~/components';
import OInsuranceLogoSVG from '~/assets/svgs/o-insurance-logo.svg';
import type { InsuranceType } from '~/@types/insurance';
import { useRoute, type RouteProp } from '@react-navigation/native';
import type { RootStackParamList } from '~/navigation/types';

import QrCodeAndroid from '~/assets/svgs/qr-code-marisa-cuida-android.svg';
import QrCodeIos from '~/assets/svgs/qr-code-marisa-cuida-ios.svg';

interface ContentProps {
  description: string | React.ReactNode;
  footer: React.ReactNode;
}

const getContent = (insuranceType: InsuranceType): ContentProps => {
  if (insuranceType === 'marisa-auto') {
    return {
      description: (
        <Text className="text-sm font-medium">
          {`Iniciamos o processo de emissão de sua apólice e agora você precisa
          completar duas etapas para ativar o seu seguro:\n\n`}
          <Text className="text-sm">{`• Realizar a vistoria veicular.\n`}</Text>
          <Text className="text-sm">
            {`• Realizar o pagamento da 1ª parcela do seguro.\n\n`}
          </Text>
          <Text className="text-sm font-medium">
            {`Para auxílio com a vistoria ou outras informações, contate:\n\n`}
          </Text>
          Assegurou
          <Text>{` (Departamento de Endossos)\n`}</Text>
          São Paulo ligue:
          <Text> (11) 2110-7727 </Text>- Ramal
          <Text>{` 7725\n`}</Text> Outros Estados ligue:{' '}
          <Text>{`0800 591 3676\n`}</Text>Email:
          <Text className="underline">{` endossos@assegurou.com.br\n`}</Text>
          <Text>{`Horário: segunda a sexta-feira, das 08h às 18h\n\n`}</Text>
          <Text>
            {`Assim que a sua apólice for aceita, você irá receber via e-mail a
            sua proposta para assinatura eletrônica.\n\n`}
            <Text className="text-xs">{`* Sujeito à aprovação\n\n\n\n`}</Text>
          </Text>
        </Text>
      ),
      footer: (
        <View className="flex-row items-center p-2 bg-secondary-200 w-full">
          <OInsuranceLogoSVG />

          <View className="w-[1px] h-full mx-2 bg-gray-100" />

          <Text className="text-gray-400 text-[10px] flex-1">
            Esta contratação é em parceria com a Ô Insurance. Todas as
            comunicações serão feitas atráves desta empresa.
          </Text>
        </View>
      ),
    };
  }
  if (['bag-protection', 'income-protection'].includes(insuranceType)) {
    return {
      description:
        'O seu bilhete de seguro será enviado para o seu e-mail e ficará disponível na área de seguros e assistências.',
      footer: (
        <View className="flex-row items-center py-3 px-7 bg-secondary-200 w-full rounded-lg justify-between">
          <MoreProtectionSVG width={140} height={45} />

          <View className="w-[1px] h-full mx-2 bg-gray-100" />

          <AssurantLogoSVG />
        </View>
      ),
    };
  }

  return {
    description:
      'Dentro de até 48h você receberá um e-mail de boas vindas da equipe Rede Mais Saúde, com todos nossos canais de atendimento!',
    footer: (
      <>
        <Text className="text-center text-dark-400 my-4 mt-0">
          Desfrute dos seus benefícios agora mesmo{' '}
          <Text className="font-medium">baixando o APP Marisa Cuida</Text>
        </Text>

        <View className="flex-row items-center justify-evenly w-full">
          <QrCodeAndroid />
          <QrCodeIos />
        </View>

        <View className="mb-8" />

        <MoreHealthSVG />
      </>
    ),
  };
};

import MoreProtectionSVG from '~/assets/svgs/more-protection-logo.svg';
import AssurantLogoSVG from '~/assets/svgs/assurant-logo.svg';

const LastPageFooter = () => {
  const {
    params: { insuranceType },
  } =
    useRoute<RouteProp<RootStackParamList, 'MarisaServicos_CheckoutSuccess'>>();

  const content = useMemo(() => getContent(insuranceType), [insuranceType]);

  return (
    <View className="items-center w-[100%] h-[300px]">
      <Text className="text-center text-base mt-4 mb-8 text-gray-400">
        {content.description}
      </Text>

      {content.footer}
    </View>
  );
};

export default LastPageFooter;
